import Card from "../components/general-site-stuff/Card";
import TacticCard from "../components/general-site-stuff/TacticCard";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import TextCarousel from "../components/general-site-stuff/TextCarousel";


import "../App.css";
import "../index.css";
import "../styles/LearnPage.css";
import EffectKey from "../components/general-site-stuff/EffectKey";

function LearnPage() {
  return (
    <div className="main">
      <Navbar />

      <div className="learnPageHeader">
        <h2>LEARNING RESOURCES</h2>
      </div>

      <hr style={{ border: '1px solid #444', margin: '1rem 0' }} /> {/* line */}

      <div className="learnSectionHeader">
        <h3>
            TACTICS AND TERMS
        </h3>
      </div>

      <EffectKey />
      
      <div className="learnSectionCaption">
        <p>
            Below are common tactics used in online radicalisation and manipulation.
            <br></br>
            Click a card to see how they steer your thoughts, fuel division, and make people act without thinking.
        </p> 
      </div>

      <div className="tacticCardGrid">
        <TacticCard
          icon="/assets/images/tactic-card-art/fear-appeals.png"
          effect= "TRIGGERS PANIC TO OVERRIDE LOGIC"
          description="uses scary language or imagery to make you 
          react emotionally before thinking critically."
          buff="EFFECT: (+📣⏰) | (-🧠❌)"
          example="constant warnings about new “kidnapping tactics” - vague details, no sources, reposted everywhere."
          deepInfo={
            <p>
              when something feels threatening, your brain switches to fight-or-flight mode, 
              and <span style={{ fontWeight: 'bold', color: '#eda138'}}>critical thinking</span> gets sidelined.
              you’re not analysing - you’re reacting. even if the post is fake or 
              <span style={{ fontWeight: 'bold', color: '#eda138'}}> exaggerated</span>, you may think, “what if it’s true?” and suddenly 
              you're sharing it without checking. especially when it sounds like something that “could” happen.
            </p>
          }
        />

        <TacticCard
          icon="/assets/images/tactic-card-art/clickbait.png"
          effect= "MISLEADING OR EXAGGERATED HEADLINES"
          description="uses dramatic or vague headlines to grab your attention 
          and make you click."
          buff="EFFECT: (+🤔📣) | (-🧠)"
          example="‘“she opened the door and instantly regretted it’ - turns out it’s a prank video."
          deepInfo={
            <p>
              clickbait relies on <span style={{ fontWeight: 'bold', color: '#eda138'}}>curiosity, not truth</span>. the headline gives you just enough to get you interested, but not enough to think critically. if a post sounds wild 
              or leaves something out, your brain thinks “i need to know more.” and if you've already clicked,
              even if it’s boring or fake, it’s too late. your curiosity has been farmed for engagement. 
            </p>
          }
        />
        
        <TacticCard
          icon="/assets/images/tactic-card-art/urgency-appeal.png"
          effect= "PUSHES YOU TO ACT BEFORE YOU PROPERLY THINK"
          description="uses time pressure or looming-threats to override 
          logic. you panic-share before you fact-check."
          buff="EFFECT: (+⏰📣) | (-🧠❌)"
          example="‘they're planning it right now. move fast or lose everything.’"
          deepInfo={
            <p>
              urgency short-circuits your logic by making something feel too important to wait. 
              when you're told "act now or else," your brain shifts into panic mode and stops 
              questioning the details. it's not about accuracy - it's about speed. <span style={{ fontWeight: 'bold', color: '#eda138'}}>the faster you're pressured to react, the less time you have to think clearly</span>. 
              even if it’s fake, you panic-share before you  <span style={{ fontWeight: 'bold', color: '#eda138'}}>fact check</span>.             
            </p>
          }
        />

        <TacticCard
          icon="/assets/images/tactic-card-art/emotional-language.png"
          effect= "AMPLIFIES FEELINGS TO BYPASS LOGIC"
          description="uses charged words to provoke anger, sadness, 
          or fear - not facts. it’s meant to spark a vibe, not a thought."
          buff="EFFECT: (+📣💢) | (-🧠❌)"
          example="‘this disgusting attack on our children is pure evil. 
          how much longer will you stay silent?’"
          deepInfo={
            <p>
              emotional language hits harder. words like “disgusting,” “evil,” or 
              “heroic” aren’t just spicy - they bypass logic and trigger feelings first, facts later. 
              once your emotions are stirred, <span style={{ fontWeight: 'bold', color: '#eda138'}}>it’s easier to guide you </span>
              towards outrage, fear, or loyalty."
            </p>
          }
        />
        
        </div>
     
      <div>

      <TextCarousel />

      </div>

          <div className="tacticCardGrid">
            <TacticCard
              icon="/assets/images/tactic-card-art/false-equivalence.png"
              effect= "UNFAIR COMPARISONS TO MISLEAD YOU"
              description="uses unfair comparisons to make two things seem 
              the same when they’re not, so your brain takes shortcuts and misses
              the logic gap."
              buff="EFFECT: (+📊) | (-🧠🌀❌🧩)"
              example="‘if we ban hate speech, we have to ban all opinions.’"
              deepInfo={
                <p>
                  our brains like shortcuts. if two things sound similar, we assume 
                  they’re equal - even when they’re not. it feels logical enough, 
                  so we stop asking questions. unlike <span style={{ fontWeight: 'bold', color: '#eda138'}}>binary thinking</span>, 
                  which splits everything into sides, false equivalence blurs the lines and <span style={{ fontWeight: 'bold', color: '#eda138'}}>pretends there’s no real difference</span> at all. 
                  false comparisons make complicated issues feel simple, but they usually leave out key differences.
                </p>
              }
            />

            <TacticCard
              icon="/assets/images/tactic-card-art/authority-appeals.png"
              effect= "USES STATUS TO SHUT DOWN QUESTIONS"
              description="uses a big name, title, or platform to make 
              something sound true (even if it’s wrong or incites harm). 
              some just repost without thinking; others know exactly what 
              they’re doing."
              buff="EFFECT: (+🫢🛡️📣) | (-🤔🧠❌)"
              example="a popular influencer resharing false info during 
              protests, leading to real-world violence against minority groups."
              deepInfo={
                <p>
                  when someone has a title, a platform, or high-status, we’re 
                  more likely to believe something. our brains take that 
                  shortcut because it feels safer to trust “the expert”  
                  with status. even if they're <span style={{ fontWeight: 'bold', color: '#eda138'}}>misinformed</span> or 
                  fuelling hate on purpose, their status makes us less likely to 
                  question what they say. 
                </p>
              }         
            />
            
            <TacticCard
              icon="/assets/images/tactic-card-art/selective-framing.png"
              effect= "PURPOSEFULLY HIDES CONTEXT TO SHAPE YOUR VIEW"
              description="uses selective wording, visuals, or 
              editing to spotlight one angle while leaving out 
              key info. the message feels complete - but it isn’t."
              buff="EFFECT: (+📣) | (-🌀🧠🧩❌📊)"
              example="video footage shows protest chaos - but the clip 
              starts after tear gas was fired."
              deepInfo={
                <p>
                    when only one angle is shown, your brain fills in the gaps. 
                    selective framing subtly controls the way something feels by 
                    focusing on what helps the message and <span style={{ fontWeight: 'bold', color: '#eda138'}}>leaving the rest out</span>. 
                    maybe it cuts a quote, zooms in on a reaction, or skips the 
                    first half of an event. it gives you just enough to think you 
                    understand, while shaping your takeaway without saying 
                    anything outright. 
                </p>
              }
            />

            <TacticCard
              icon="/assets/images/tactic-card-art/rage.png"
              effect= "DESIGNED TO SPARK OUTRAGE AND GO VIRAL"
              description="uses emotionally explosive content to trigger anger, 
              fear, or disgust - not curiosity like clickbait, but raw 
              outrage designed to drive comments and shares."
              buff="EFFECT: (+💢📣) | (-❌🌀🧠🎯🤔)"
              example="‘my kid can’t even say what they believe at 
              school anymore without getting cancelled - 
              this country’s gone insane.’"
              deepInfo={
                <p>
                  anger hijacks your brain’s reward system and makes you react 
                  fast. even if you disagree, reply, or quote-post to call it out 
                  - that <span style={{ fontWeight: 'bold', color: '#eda138'}}>interaction boosts the post</span>. 
                  algorithms treat outrage the same as support. you may think 
                  you're fighting it, but you're feeding it.
                </p>
              }
            />
        
        </div>
      
        <div className="tacticCardGrid">
            <TacticCard
              icon="/assets/images/tactic-card-art/exaggeration.png"
              effect= "BLOWS THINGS WAY OUT OF PROPORTION TO STIR PANIC OR CONTROL THE NARRATIVE"
              description="takes a small detail and makes it sound like the end of the world to 
              get you riled up. everything’s either “destroying society,” “the worst thing 
              ever,” or “proof it’s all rigged.”"
              buff="EFFECT: (+💢⏰📣) | (-🧠❌🌀)"
              example="‘this ONE post proves everything we’ve been warning you about!’"
              deepInfo={
                <p>
                  when something feels huge or dramatic, your brain <span style={{ fontWeight: 'bold', color: '#eda138'}}>sees it as urgent  </span>
                  - even if it’s not. exaggeration hijacks your attention by blowing 
                  details out of proportion, making everything sound like a crisis. 
                  once your emotions kick in, you’re less likely to pause and ask, 
                  “is this actually that deep?”  it thrives on <span style={{ fontWeight: 'bold', color: '#eda138'}}>urgency and outrage, not accuracy</span>.
                  the louder it is, the more likely you’ll share it - 
                  whether it’s actually true or not.
                </p>
              }
            />

            <TacticCard
              icon="/assets/images/tactic-card-art/memes.png"
              effect= "DEFLECTS CRITICISM BY DISGUISING HARMFUL MESSAGES AS SATIRE"
              description="frames toxic or extreme ideas as “just jokes,” using 
              memes, sarcasm, or ironic content to push harmful messages 
              without being held accountable."
              buff="EFFECT: (+🫢🌀) | (-❌🧠🧭🧩)"
              example="‘edgy memes that look ironic - until you realise the followers mean it.’"
              deepInfo={
                <p>
                  irony gives people cover. when a bad take is wrapped in a joke, 
                  it’s <span style={{ fontWeight: 'bold', color: '#eda138'}}>easy to spread without consequences.</span>
                  it creates spaces where people can share extreme ideas and beliefs - racism, misogyny, 
                  conspiracy theories - and if they get called out, they 
                  just say “relax, it’s a joke.” it’s <span style={{ fontWeight: 'bold', color: '#eda138'}}>disarming, plausible deniability </span>
                  disguised in memes.
                </p>
              }
            />

            <TacticCard
              icon="/assets/images/tactic-card-art/binary.png"
              effect= "FORCES EVERYTHING INTO “EITHER/OR” BOXES SO NUANCE GETS LOST"
              description="reduces messy real-world issues 
              into two sides - hero vs villain, right vs wrong - 
              so you’re forced to pick a team instead of 
              thinking it through."
              buff="EFFECT: (+💥) | (-🧠❌🧩)"
              example="debates around policing framed as either 
              “support the police” or “abolish everything,” 
              ignoring any middle-ground reforms or nuance."
              deepInfo={
                <p>
                  your brain likes clean answers. when things feel overwhelming, 
                  binary thinking gives you a <span style={{ fontWeight: 'bold', color: '#eda138'}}>sense of clarity - a team to root for and a villian to blame</span>.
                  it simplifies the chaos of reality into something manageable. 
                  but in doing that, it erases context, lived experience, grey 
                  areas and middle ground. it’s easier to say “they’re all evil” 
                  than to ask “why do they think that?” and extremists on every 
                  side love it as <span style={{ fontWeight: 'bold', color: '#eda138'}}>nuance makes mobilisation harder</span>.
                </p>
              }
            />

            <TacticCard
              icon="/assets/images/tactic-card-art/pseudo.png"
              effect= "USES 'SMART LANGUAGE' TO MASK BAD ARGUMENTS"
              description="dresses weak ideas in 'smart-sounding' language - like 
              overexplaining, name-dropping, or info-dumping to intimidate 
              people out of pushing back."
              buff="EFFECT: (+🫢📊🤔) | (-🧠📉❌)"
              example="long social media threads with charts and fake credentials that just go in circles."
              deepInfo={
                <p>
                  people tend to <span style={{ fontWeight: 'bold', color: '#eda138'}}>associate confidence and complex language with intelligence</span>. 
                  when someone uses complex language or 
                  overloads you with info, it can feel intimidating to 
                  push back - even if what they’re saying doesn’t actually 
                  make sense. it’s not about being right, it’s about <span style={{ fontWeight: 'bold', color: '#eda138'}}>sounding unchallengeable</span>.
                  and in online spaces, acting smarter than everyone else 
                  often gets rewarded more than being right.
                </p>
              }
            />
      </div>
      <Footer />
    </div>
  );
}

export default LearnPage;